<template>
  <div>
    <div class="hvh-flex align-center" :class="{ 'validation-error': validationError }">
      <HvhUploadFile :value="value" :accept="accept" :rules="rules" @input="$emit('input', $event)" ref="uploadFile" />
      <span class="ml-1" @click="pickFile">{{ value?.name || text || 'Choose File...' }}</span>
    </div>
    <div class="v-text-field__details" v-if="validationError">
      <div class="v-messages theme--light error--text">
        <div class="v-messages__wrapper">
          <div class="v-messages__message">{{ validationError }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HvhUploadFile from './HvhUploadFile.vue';
export default {
  components: { HvhUploadFile },
  props: {
    rules: {
      default: () => [],
      type: Array,
    },
    accept: {
      type: String,
    },
    text: {},
    value: {},
  },
  inject: ['form'],
  data() {
    return {
      validationError: null,
    };
  },
  methods: {
    pickFile() {
      this.$refs.uploadFile.$refs.input.click();
    },
    validate() {
      this.validationError = this.rules
        .map(f => f(this.value))
        .find(f => f !== true);
      return !this.validationError;
    },
  },
  watch: {
    value() {
      this.validate();
    },
  },
  created() {
    this.form && this.form.register(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.form && this.form.unregister(this);
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisHvhUploadFileGroup'] = this;
  },
}
</script>

<style lang="scss" scoped>
.svg_icon {
  height: 30px;
  cursor: pointer;
}

.validation-error {
  color: rgb(255, 82, 82);
}
</style>